import request from '@/utils/index.js'

export function apiGetActivationCode(params, token) {
  return request({
    url: '/official/space/activation_code',
    method: 'get',
    headers: {
      port: 8000,
      token: token
    },
    params
  })
}
export function apiSearchMachine(params, token) {
  return request({
    url: '/official/space/search_machine',
    method: 'get',
    headers: {
      port: 8000,
      token: token
    },
    params,
  })
}
export function apiPayCode(params, token) {
  return request({
    url: '/official/pay/code',
    method: 'post',
    headers: {
      port: 8000,
      token: token
    },
    data: params,
  })
}
export function apiPayPoll(params, token) {
  return request({
    url: '/official/pay/pay_poll',
    method: 'get',
    headers: {
      port: 8000,
      token: token
    },
    params,
  })
}